import { IReleaseNote } from "../types"

export const RELEASE_1_4_4: IReleaseNote = {
    status: "PAST",
    title: "v1.4.4",
    date: "17th September 2024",
    releaseType: "Patch",
    notesBodyAllUsers: [
        {
            heading: "Introduction",
            content:
                "Patch 1.4.4 makes a small bug fix to the emails that go out to installers post approval of an application",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using the web portal",
            content: "The following change has been been added:",
            bullets: [
                "We have fixed a bug causing some boilerplate text to be included in approval emails for demand applications to installers (installers only, not customers). This has been removed",
            ],
        },
        {
            heading: "For installers using our APIs",
            content: "The following change has been been added:",
            bullets: [
                "We have fixed a bug causing some boilerplate text to be included in approval emails for demand applications to installers (installers only, not customers). This has been removed",
            ],
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using the web portal",
            content: "The following change has been been added:",
            bullets: [
                "We have fixed a bug causing some boilerplate text to be included in approval emails for demand applications to installers (installers only, not customers). This has been removed",
            ],
        },
        {
            heading: "For DNOs using our APIs",
            content: "The following change has been been added:",
            bullets: [
                "We have fixed a bug causing some boilerplate text to be included in approval emails for demand applications to installers (installers only, not customers). This has been removed",
            ],
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
}
